// Global client configuration
// This file contains version information and other client constants

export const CLIENT_CONFIG = {
  // Client version sent to backend in x-blidz-client-version header
  VERSION: "100.0.0",

  // Terms and conditions version for API calls
  TERMS_VERSION: 6,

  // Other client constants can be added here
  APP_NAME: "Blidz Web",
  PLATFORM: "web",
} as const;

export default CLIENT_CONFIG;
